// extracted by mini-css-extract-plugin
module.exports = {"section":"NotFound_section__33E8T"};